// extracted by mini-css-extract-plugin
module.exports = {"alignGraphSubTitle":"GraphSubTitle_alignGraphSubTitle__hZ2Mz","leftSection":"GraphSubTitle_leftSection__iw64u","rightSection":"GraphSubTitle_rightSection__r07r3"};